import React, { useState } from 'react';
import NavigationLinkDropdown from './dropdownstyle';
import { ContentfulContentType } from '../types/enums';
import { DropdownMenu as DropdownMenuProps } from './types/types';
import ImageLinkWithTextDropdownMenu from './components/ImageLinkWithTextDropdownMenu';
import HeadlineDropdownMenu from './components/HeadlineDropdownMenu';
import SetOfDropdownMenu from './components/SetOfDropdownMenu';
import CategoryLinks from './components/CategoryLinks';
import CTALink from './components/CTALink';

const LinkedNavigationStyleLinks = (props: Partial<DropdownMenuProps>) => {
  const [showDropDown, setShowId] = useState(false);
  const {
    index, linkUrl, displayText, linkedContent,
  } = props;

  const renderContentSections = (content) => {
    const categorizedContent = content?.sys?.contentType?.sys?.id || content?.contentfulContentType;

    switch (categorizedContent) {
      case ContentfulContentType.COLLAPSIBLELIST:
        return (
          <CategoryLinks
            listHeader={content.listHeader}
            list={content.list}
          />
        );
      case ContentfulContentType.CTA:
        return (
          <CTALink
            url={content.url}
            function={content.function}
            displayText={content.displayText}
          />
        );
      case ContentfulContentType.HEADLINE:
        return (
          <HeadlineDropdownMenu
            contentfulid={content.contentfulid}
            header={content.header}
            alignment={content.alignment}
            subcopy={content.subcopy}
            subCopySmall={content.subCopySmall}
            link={content.link}
          />
        );
      case ContentfulContentType.IMAGELINKWITHTEXT:
        return (
          <ImageLinkWithTextDropdownMenu
            url={content.imageUrl || content.url}
            image={content.image}
            displayText={content.displayText}
            textAlignment={content.textAlignment}
          />
        );
      case ContentfulContentType.SETOF:
        return (
          <SetOfDropdownMenu
            fields={content}
          />
        );
      default:
        return <div data-content-type="not-found">Unknown Content Type</div>;
    }
  };

  return (
    <NavigationLinkDropdown>
      <div className="sub__menu--wrapper">
        {linkUrl ? (
          <a
            href={linkUrl}
            className="anchor__has-submenu nav__anchor"
          >
            {displayText}
          </a>
        ) : (
          <button
            type="button"
            className="anchor__has-submenu nav__anchor"
            onClick={() => setShowId(!showDropDown)}
            aria-expanded={showDropDown}
            aria-controls={`${displayText}-${index}`}
          >
            <span className="display">{displayText}</span>
            {' '}
            <span className="show-inactive">
              <svg
                height="20"
                width="20"
                viewBox="0 0 20 20"
                aria-hidden="true"
                focusable="false"
                className="css-19bqh2r"
              >
                <title>Show Icon</title>
                <desc>Show Icon</desc>
                <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
              </svg>
              {' '}
            </span>
            <span className="show-active">
              <svg
                height="20"
                width="20"
                viewBox="0 0 20 20"
                aria-hidden="true"
                focusable="false"
                className="css-19bqh2r"
              >
                <title>Show Icon</title>
                <desc>Show Icon</desc>
                <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
              </svg>
              {' '}
            </span>
          </button>
        )}
        <ul
          id={`${displayText}-${index}`}
          className="sub__menu"
        >
          <div className="sub__menu--show">
            <div className="sub__menu--content">
              {linkedContent?.map((content, index) => (
                <li key={index}>
                  <div className="sub__menu--column-content">
                    {renderContentSections(content)}
                  </div>
                </li>
              ))}
            </div>
          </div>
        </ul>
      </div>
      <div className="overlay" />
    </NavigationLinkDropdown>
  );
};

export default LinkedNavigationStyleLinks;
